import React from 'react'
import PropTypes from 'prop-types'
import CalendarAddOnIcon from 'components/material-symbol/icons/CalendarAddOn'
import { OUTLINED_INPUT_FOCUS_BORDER } from 'lib/form-field-styles'

const CalendarBookSlotIcon = ({ className }) => (
  <CalendarAddOnIcon
    className={className}
    fill={0}
    htmlColor={OUTLINED_INPUT_FOCUS_BORDER}
    aria-hidden
  />
)

CalendarBookSlotIcon.propTypes = {
  className: PropTypes.string,
}

export default CalendarBookSlotIcon
